import React, { useState } from "react";
import { Card, Table, Form, Dropdown, Row, Col, Pagination } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import EditBudgetModal from "../../modals/financial-dashboard/EditBudgetModal";
import BudgetDeleteModal from "../../modals/financial-dashboard/BudgetDeleteModal";
// import EditBudgetModal from "../../modals/financial-dashboard/EditBudgetModal";
// import BudgetDeleteModal from "../../modals/financial-dashboard/BudgetDeleteModal";
import { FiChevronDown } from "react-icons/fi";



const initialData = [
  {
    id: 1,
    title: "Office Supplies",
    type: "Category",
    start: "14 Jan 2024",
    end: "13 Nov 2024",
    revenue: 250000,
    expense: 150000,
    tax: 10000,
    amount: 90000,
  },
  {
    id: 2,
    title: "Recruitment",
    type: "Category",
    start: "21 Jan 2024",
    end: "20 Nov 2024",
    revenue: 300000,
    expense: 200000,
    tax: 15000,
    amount: 85000,
  },
  {
    id: 3,
    title: "Tender",
    type: "Project",
    start: "10 Feb 2024",
    end: "08 Dec 2024",
    revenue: 200000,
    expense: 170000,
    tax: 5000,
    amount: 25000,
  },
  {
    id: 4,
    title: "Salary 2024",
    type: "Category",
    start: "18 Feb 2024",
    end: "16 Dec 2024",
    revenue: 300000,
    expense: 200000,
    tax: 15000,
    amount: 85000,
  },
];

export default function BudgetList() {
  const [data, setData] = useState(initialData);

  const [selected, setSelected] = useState([]);
  const [editItem, setEditItem] = useState(null);
  const [deleteShow, setDeleteShow] = useState(false);
 const [search, setSearch] = useState("");
  const [sort, setSort] = useState("Last 7 Days");
    const [rows, setRows] = useState(10);

  // Search filter
  const filtered = data.filter((item) =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  // Select all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(filtered.map((item) => item.id));
    } else {
      setSelected([]);
    }
  };

  // Single select
  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  // Delete action
  const handleDelete = () => {
    setData(data.filter((item) => !selected.includes(item.id)));
    setSelected([]);
    setDeleteShow(false);
  };

  return (
    <>
      <Card className="shadow-sm budget-list border-0">
        {/* HEADER */}
   <Card.Header className="budget-header">

      {/* 🔥 LINE 1 */}
      <div className="header-top">
        <h5 className="title">Budget List</h5>

        <Dropdown>
          <Dropdown.Toggle className="sort-btn">
            Sort By : {sort} <FiChevronDown />
          </Dropdown.Toggle>

          <Dropdown.Menu className="custom-dropdown" align="end">
            <Dropdown.Item onClick={() => setSort("Recently Added")}>
              Recently Added
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSort("Ascending")}>
              Ascending
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSort("Descending")}>
              Descending
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* 🔥 LINE 2 */}
      <div className="header-bottom">
        
        {/* LEFT */}
        <div className="row-control">
          <span>Row Per Page</span>

          <select
            value={rows}
            onChange={(e) => setRows(e.target.value)}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>

          <span>Entries</span>
        </div>

        {/* RIGHT */}
        <Form.Control
          placeholder="Search"
          className="search-box"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>

      {/* CSS */}
      <style>{`
        .budget-header {
          background: #fff;
          padding: 15px;
        }
          budget-list{
           border-radius: 5px;
          border: 2px solid #e5e7eb;
          }
.dropdown-toggle::after {
  display: none !important;
}
        /* 🔥 TOP LINE */
        .header-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        .title {
          font-size: 18px;
          font-weight: 600;
        }

        /* 🔥 BOTTOM LINE */
        .header-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
        }

        /* ROW CONTROL */
        .row-control {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #374151;
        }

        .row-control select {
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          padding: 4px 8px;
          font-size: 14px;
        }

        /* SORT BUTTON */
        .sort-btn {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 6px 12px;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
          color: #111;
        }

        .sort-btn:hover,
        .sort-btn:focus {
          background: #fff !important;
          box-shadow: none !important;
          border-color: #e5e7eb !important;
          color: #111;

        }

        /* DROPDOWN */
        .custom-dropdown {
          border-radius: 10px;
          border: 1px solid #eee;
          padding: 8px 0;
        }

        .custom-dropdown .dropdown-item {
          padding: 10px 15px;
          font-size: 14px;
        }

        .custom-dropdown .dropdown-item:hover {
          background: #f3f4f6;
        }

        /* SEARCH */
        .search-box {
          width: 200px;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
        }

        .search-box:focus {
          box-shadow: none;
          border-color: #ff7a2f;
        }
.custom-pagination .page-link {
  color: #ff6b1a;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin: 0 4px;
}

.custom-pagination .page-link:hover {
  background-color: #ffe3d3;
  color: #ff6b1a;
}

.custom-pagination .page-item.active .page-link {
  background-color: #ff6b1a;
  border-color: #ff6b1a;
  color: #fff;
}

.custom-pagination .page-item.disabled .page-link {
  color: #ccc;
}
        /* MOBILE */
        @media (max-width: 768px) {
          .header-top,
          .header-bottom {
            flex-direction: column;
            align-items: flex-start;
          }

          .search-box {
            width: 100%;
          }
        }
      `}</style>
    </Card.Header>

        {/* TABLE */}
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table hover className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th>
<Form.Check
  type="checkbox"
  style={{ accentColor: "orange" }}
  checked={selected.length === filtered.length}
  onChange={handleSelectAll}
/>
                  </th>
                  <th>Budget Title</th>
                  <th>Budget Type</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Total Revenue</th>
                  <th>Total Expense</th>
                  <th>Tax Amount</th>
                  <th>Budget Amount</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <Form.Check
                        checked={selected.includes(item.id)}
                        onChange={() => handleSelect(item.id)}
                      />
                    </td>

                    <td className="fw-medium">{item.title}</td>
                    <td>{item.type}</td>
                    <td>{item.start}</td>
                    <td>{item.end}</td>
                    <td>{item.revenue}</td>
                    <td>{item.expense}</td>
                    <td>{item.tax}</td>
                    <td>{item.amount}</td>

                    <td>
                      <div className="d-flex gap-2">
                        <FiEdit
                          className="text-dark cursor-pointer"
                          onClick={() => setEditItem(item)}
                        />
                        <FiTrash2
                          className="text-dark cursor-pointer"
                          onClick={() => {
                            setSelected([item.id]);
                            setDeleteShow(true);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* FOOTER */}
    <div className="d-flex justify-content-between align-items-center p-3">
  <span>
    Showing 1 - {filtered.length} of {data.length} entries
  </span>

  <Pagination className="mb-0 custom-pagination">
    <Pagination.Prev />
    <Pagination.Item active>1</Pagination.Item>
    <Pagination.Next />
  </Pagination>
</div>
        </Card.Body>
      </Card>


      <EditBudgetModal
        show={!!editItem}
        data={editItem}
        onHide={() => setEditItem(null)}
      />

      <BudgetDeleteModal


        show={deleteShow}
        onHide={() => setDeleteShow(false)}
        onDelete={handleDelete}
      />
      <style>
          {

               `
               .orange-checkbox .form-check-input:checked {
  background-color: orange;
  border-color: orange;
}

.orange-checkbox .form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 165, 0, 0.25);
}
  


`
          }
      </style>
    </>
  );
}